import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-btb-commission-list',
  templateUrl: './btb-commission-list.component.html',
  styleUrls: ['./btb-commission-list.component.scss']
})
export class BtbCommissionListComponent {
  @Input() conditions: string[] = [];
  @Input() showEditButton: boolean = false;
  @Output() editConditions = new EventEmitter<void>();

  onEditConditions() {
    this.editConditions.emit();
  }
}
